export type ContrastingColors = 'orange-blue' | 'red-green' | 'yellow-purple';

export type ThemeValues = 'light' | 'dark';

export function isAlphaFlashHost(): boolean {
  const hostname = window.location.hostname;

  const alphaflashHost = process.env.REACT_APP_ALPHAFLASH_HOST;

  return hostname === alphaflashHost;
}

export function getBrandLogo(): string {
  if (isAlphaFlashHost()) return '/alphaflash/brand.png';

  return '/logo-white.svg';
}

export function getBrandAttribute(): string | undefined {
  return isAlphaFlashHost() ? 'alphaflash' : undefined;
}

export function getDefaultThemeForHost(): ThemeValues {
  return getBrandAttribute() === 'alphaflash' ? 'light' : 'dark';
}
